import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var objectRemoveMatchedKey = function objectRemoveMatchedKey() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var alias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.entries(data).reduce(function (clean, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return alias[key] ? clean : _extends({}, clean, _defineProperty({}, key, value));
  }, {});
};
export default objectRemoveMatchedKey;